/* eslint-disable max-len */
/* eslint-disable react/no-array-index-key */
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import BasicInput from '../../../components/BasicInput';
import ButtonTextIcon, { BtnType } from '../../../components/BtnIcon';
import api from '../../../config/axios';
import { maskDate } from '../../../helpers/inputMasks.js';
import PrimaryModalContent, { IPrimaryModalContent } from '../PrimaryModalContent';

interface PageProps {
    setModal: (arg0: React.ReactNode) => void;
    setLoading: (arg0: boolean) => void;
}

export default function LifesByPeriod({ setModal, setLoading }: PageProps) {
  const [initialDateInput, setInitialDateInput] = useState('01-01-2022');
  const [finalDateInput, setFinalDateInput] = useState(DateTime.now().toFormat('dd-MM-yyyy'));
  const [token] = useState({ headers: { Authorization: `bearer ${localStorage.getItem('adminToken')}` } });
  const [modalProps, setModalProps] = useState<IPrimaryModalContent | null>(null);
  const [modalBtnRef] = useState(React.createRef<any>());
  const [showBlocked, setShowBlocked] = useState(false);
  const [showCanceled, setShowCanceled] = useState(false);
  const [showIsActive, setShowIsActive] = useState(false);
  const [abstractBtn01, setAbstractBtn01] = useState(false);
  const [abstractBtn02, setAbstractBtn02] = useState(false);

  function resolveBody() {
    if (showBlocked) {
      return {
        showBlocked: true,
      };
    }
    if (showCanceled) {
      return {
        showCanceled: true,
      };
    }
    if (showIsActive) {
      return {
        showIsActive: true,
      };
    }
    if (abstractBtn01) {
      return {};
    }
    if (abstractBtn02) {
      return {};
    }
    return {};
  }

  function setActiveCheck(check: 'active' | 'blocked' | 'canceled' | 'abstractbtn1' | 'abstractbtn2') {
    if (check === 'active') {
      setShowIsActive((prev) => !prev);
      setShowCanceled(false);
      setShowBlocked(false);
    } else if (check === 'blocked') {
      setShowIsActive(false);
      setShowCanceled(false);
      setShowBlocked((prev) => !prev);
    } else if (check === 'canceled') {
      setShowIsActive(false);
      setShowCanceled((prev) => !prev);
      setShowBlocked(false);
    } else if (check === 'abstractbtn1') {
      setShowIsActive(false);
      setShowCanceled(false);
      setShowBlocked(false);
      setAbstractBtn01((prev) => !prev);
      setAbstractBtn02(false);
    } else if (check === 'abstractbtn2') {
      setShowIsActive(false);
      setShowCanceled(false);
      setShowBlocked(false);
      setAbstractBtn01(false);
      setAbstractBtn02((prev) => !prev);
    }
  }

  async function fetchData(initialDate: string, finalDate: string) {
    try {
      const response = await api.post('/admin/reports/byperiod/lifesbyperiod', {
        initialDate: `${initialDate} 00:00:00`,
        finalDate: `${finalDate} 23:59:59`,
        ...resolveBody(),
      }, token);
      return response;
    } catch (err: any) {
      throw new Error('Erro ao buscar relatórios.');
    }
  }

  async function validateDate() {
    try {
      const initialDateAsDateTime = DateTime.fromFormat(initialDateInput, 'dd-MM-yyyy');
      const finalDateAsDateTime = DateTime.fromFormat(finalDateInput, 'dd-MM-yyyy');
      if (!initialDateAsDateTime.isValid) {
        throw new Error('Data inicial inválida.');
      }
      if (!finalDateAsDateTime.isValid) {
        throw new Error('Data final inválida.');
      }

      if (initialDateAsDateTime > finalDateAsDateTime) {
        throw new Error('Data inicial maior que a data final.');
      }
      return {
        initialDateAsDateTime,
        finalDateAsDateTime,
      };
    } catch (err: any) {
      throw new Error(err.message);
    }
  }

  async function callApi() {
    try {
      setLoading(true);
      const date = await validateDate();
      const response = await fetchData(date.initialDateAsDateTime.toFormat('dd-MM-yyyy'), date.finalDateAsDateTime.toFormat('dd-MM-yyyy'));
      setModalProps(response.data);
      modalBtnRef.current.click();
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setModal(<p>{err.message}</p>);
    }
  }

  return (
    <>
      <div className="row products">
        <div className="col-12 p-0 card-bg p-4">
          <h1>
            Relatórios de
            {' '}
            <strong className="fw-bold text-primary">vendas/inclusão</strong>
            {' '}
            de associados por período
          </h1>
          <div className="row">
            {/* <div className="col-12 allow-modifications mb-4">
              <input type="checkbox" onChange={() => setActiveCheck('active')} checked={showIsActive} />
              <p>Apenas usuários ativos.</p>
            </div>
            <div className="col-12 allow-modifications mb-4">
              <input type="checkbox" onChange={() => setActiveCheck('blocked')} checked={showBlocked} />
              <p>Apenas bloqueados temporariamente.</p>
            </div>
            <div className="col-12 allow-modifications mb-4">
              <input type="checkbox" onChange={() => setActiveCheck('canceled')} checked={showCanceled} />
              <p>Apenas cancelados.</p>
            </div> */}
            <div className="col-12 allow-modifications mb-4">
              <input type="checkbox" onChange={() => setActiveCheck('abstractbtn1')} checked={abstractBtn01} />
              <p>Incluir associados ativos, bloqueados temporariamente e cancelados.</p>
            </div>
            <div className="col-12 allow-modifications mb-4">
              <input type="checkbox" onChange={() => setActiveCheck('abstractbtn2')} checked={abstractBtn02} />
              <p>Vendas no periodo / Inclusao no sistema.</p>
            </div>
            <div className="col-4">
              <BasicInput
                id="indication-initial-date"
                label="Data Inicial"
                readOnly={false}
                helper="Ex: 13-06-2022"
                error=""
                value={initialDateInput}
                onChange={(data) => setInitialDateInput(maskDate(data))}
                type=""
              />
            </div>
            <div className="col-4">
              <BasicInput
                id="indication-initial-date"
                label="Data final"
                readOnly={false}
                helper="Ex: 22-06-2022"
                error=""
                value={finalDateInput}
                onChange={(data) => setFinalDateInput(maskDate(data))}
                type=""
              />
            </div>
            <div className="col-4 d-flex align-items-center mb-3">
              <ButtonTextIcon
                label="Gerar relatório"
                type={BtnType.PRIMARY}
                icon="search"
                active
                onClick={() => callApi()}
                ref={null}
              />
            </div>
          </div>
        </div>
      </div>
      <button type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#LifesByPeriod" ref={modalBtnRef}>
        Launch static backdrop modal
      </button>
      <PrimaryModalContent
        series={modalProps ? modalProps.series : []}
        data={modalProps ? modalProps.data : []}
        id="LifesByPeriod"
        labelText="VIDAS"
        title="Vidas por contrato baseado em período"
        initialDate={initialDateInput}
        finalDate={finalDateInput}
      />
    </>
  );
}
